import React, { useEffect, useRef, useState } from "react";
import { Card, Space, AutoComplete, Button, Spin, Empty  } from 'antd';
import { EditOutlined, EllipsisOutlined, SettingOutlined } from '@ant-design/icons';
import { Link, useHistory } from "react-router-dom";
import "../ECatalogComponents/productslide.css";

import Slider from "react-slick";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { BsCartPlus } from "react-icons/bs";
import { useCart } from 'react-use-cart';
import ProductItem from "./ProductItem";
import { SearchCatalogItem } from "../../Services/EcatalogService";
import { IProductItem } from "../../IRequestModel/ECatalog/IProductItemModel";
import { MapsDataToProductObject } from "../../Helper/ECatalogHelper";
import { useUserContext } from "../../Context/UserContext";

const { Meta } = Card;

interface Props {
    showSlide: boolean,
    limitItem?: number,
    showFavorite?: boolean,
    showQuantity?: boolean
}

export default  function Products (props: Props) {
    const [userData, setUserData] = useUserContext();
    const [products, setProducts] = useState<IProductItem[]>([]);
    const [productsFavorite, setProductsFavorite] = useState<IProductItem[]>([]);
    const customSlider = useRef<Slider>(null);
    const { addItem, emptyCart } = useCart();
    const [loadingFavorite, setLoadingFavorite] = useState<boolean>(false);
    const [loadingProduct, setLoadingProduct] = useState<boolean>(false);
    const history = useHistory();
    useEffect(() => {
        setLoadingProduct(true);
        getProducts()
    }, [])

    async function getProducts() {
        //await getFavorite();
       
        const dataJson = {
            SearchItem : "",
            CategoryCode :0,
            EmployeeId: userData.EmployeeId,
            QueryLastBuy:true,
          };
        let response = await SearchCatalogItem(dataJson);
        const data = response.data;
       
        if (data === undefined) return;
        let productItem: IProductItem[] = MapsDataToProductObject(data);

        //setProductsFavorite(shuffle(productItem.filter(x => x.isFavorite)).slice(0, 10))
        setProducts(props.limitItem != undefined && data != null ? shuffle(productItem).slice(0, props.limitItem) : productItem);
        setLoadingProduct(false);
    }

    // async function getFavorite(){
    //   setLoadingFavorite(true);
    //   const dataJson = {
    //     SearchItem : "",
    //     CategoryCode : 0,
    //     EmployeeId: userData.EmployeeId,
    //     IsFavorite:true,
    //   };
    // let response = await SearchCatalogItem(dataJson);
    // const data = response.data;
   
    // if (data === undefined) return;
    // let productItem: IProductItem[] = MapsDataToProductObject(data);

    // setProductsFavorite(shuffle(productItem.filter(x => x.isFavorite)).slice(0, 10));
    // setLoadingFavorite(false);
    // }

    async function getProductsFavorite() {
        const dataJson = {
            searchItem : "",
            Catagoly :0,
            EmployeeId: userData.EmployeeId
          };
        let response = await SearchCatalogItem(dataJson);
        const data = response.data;
       
        if (data === undefined) return;
        let productItem: IProductItem[] = MapsDataToProductObject(data);

        setProductsFavorite(shuffle(productItem.filter(x => x.isFavorite)).slice(0, 10))
    }
    

    const favoriteCallback = async (data:any) => {
        //await getProductsFavorite();
        //await getFavorite();
    }

    const shuffle = (array: any[]) => { 
        return array.sort(() => Math.random() - 0.5); 
    }; 

    var settings = {
        /*rows: 2,*/
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 6,
        initialSlide: 0,
        prevArrow: <FaAngleLeft />,
        nextArrow: <FaAngleRight/>,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 4,
              infinite: true,
              dots: true
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
              initialSlide: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      };
    return (
        <>
            {/* <Card className="ecatalog-form-search-card" bordered={false} title="สินค้าที่ชอบ" size={"small"} style={{marginBottom: "8px"}}>
                <div style={{width: "100%", padding:"0px 20px" }}>
                   {
                     loadingFavorite ? ( <Spin/>) : (

                      productsFavorite.length > 0 ? (
                        <Space style={{ display: "flex" }} wrap>
                        {
                            productsFavorite.map(product => (
                                <>
                                    <ProductItem key={product.rowKey} product={product} ShowQuantity={props.showQuantity} FavoriteCallback={favoriteCallback} ></ProductItem>
                                </>
                          ))
                          }
                      </Space>
                      ) : (<Empty />)
                       

                     )
                   }
                 
                </div>
            </Card> */}
            <Card className="ecatalog-form-search-card" bordered={false} title="สินค้าที่เคยซื้อ" size={"small"}>
                <div style={{width: "100%", padding:"0px 20px" }}>
                   {
                    loadingProduct ? ( <Spin/>) : (
                      products.length > 0 ? (
                        <Space style={{ display: "flex" }} wrap>
                        {
                            products.map(product => (
                                    <>
                                        <ProductItem key={product.rowKey} product={product} ShowQuantity={props.showQuantity} FavoriteCallback={favoriteCallback} ></ProductItem>
                                    </>
                            ))
                            }
                        </Space>
                      ) : (<Empty/>)
                     
                    )


                   }

                   

                </div>
                {/* <Products showSlide={false} limitItem={20} showQuantity={isEditECatalog} /> */}
            </Card>
        </>

    )

    // return (
    //     <>
    //         <div style={{width: "100%", padding:"0px 20px" }}>
    //         {
    //             props.showSlide == null ||  props.showSlide ? (
    //                 <Space style={{ display: "flex" }} wrap>
    //                 {/* <Slider ref={customSlider} {...settings} className="slider-product"> */}
    //             {
                    
    //                 products.map(product => (
    //                         <>
    //                             <ProductItem key={product.id} product={product} FavoriteCallback={favoriteCallback} ></ProductItem>
    //                         </>
    //                 ))
    //             }

    //                 {/* </Slider> */}
    //                 </Space>

    //             ) 
    //             :
    //             (
    //                 <Space style={{ display: "flex" }} wrap>
    //                     {
    //                         products.map(product => (
    //                             <>
    //                                 <ProductItem key={product.id} product={product} ShowQuantity={props.showQuantity} FavoriteCallback={(e) => {}} ></ProductItem>
    //                             </>
    //                         ))
    //                     }
            
                    
    //                 </Space>

    //             )
    //         }
    //         </div>

    //     </>
    // )
};